<template>
  <v-container class="main-container responsive-height">
    <v-row>
      <v-col cols="12">
        <v-card
          class="elevation-0 rounded-0 faq-card pb-3"
          :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2 '"
        >
          <v-card-title>
            <v-icon class="mr-3" color="teal-lighten-1"
              >mdi mdi-chat-outline</v-icon
            >
            Frequently Asked Questions
          </v-card-title>
          <v-expansion-panels v-model="panel" multiple flat tile>
            <v-expansion-panel v-for="(item, index) in faqs" :key="item?.id">
              <v-expansion-panel-header
                :class="
                  $vuetify.theme.dark ? 'blue-lighten-1' : 'white-lighten-1'
                "
              >
                <span class="numbers">{{ index+1 }}</span
                >{{ item?.question }}
              </v-expansion-panel-header>
              <v-expansion-panel-content
                :class="
                  $vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'
                "
              >
                <p>{{ item?.answer }}</p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { FAQS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      panel: [0],
    };
  },
  computed: {
    ...mapState("faq", ["faqs"]),
  },
  methods: {
    ...mapActions("faq", [FAQS__ACTIONS.FAQS]),
  },
  mounted() {
    this[FAQS__ACTIONS.FAQS]();
  },
};
</script>
